__turbopack_context__.v({
  "closeIconWrap": "xLumhW_closeIconWrap",
  "desktop-only": "xLumhW_desktop-only",
  "mobile-break": "xLumhW_mobile-break",
  "rgg-promo": "xLumhW_rgg-promo",
  "ribbonAbTestA": "xLumhW_ribbonAbTestA",
  "ribbonContainer": "xLumhW_ribbonContainer",
  "ribbonContainerSimple": "xLumhW_ribbonContainerSimple",
  "ribbonLink": "xLumhW_ribbonLink",
  "ribbonPromo": "xLumhW_ribbonPromo",
  "ribbonSpecialBr": "xLumhW_ribbonSpecialBr",
  "ribbonsub": "xLumhW_ribbonsub",
  "special-br-1": "xLumhW_special-br-1",
});
